import React, { useEffect, useState } from 'react'
import PhotographerProfileForm from './PhotographerProfileForm/PhotographerProfileForm';
import { useNavigate } from 'react-router-dom';

const PhotographerProfile = () => {
    const navigate=useNavigate()
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
    });



    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;

            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);

        return () => clearInterval(interval);
    }, [isSidebarOpen]);

    return (
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
            style={{ marginTop: "100px" }}
        >
             <button
          className="admin-back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>
            <div className="page-inner-wrapper">

                {/* <h2 className="page-title">Photographer Profile</h2> */}
                <PhotographerProfileForm/>
            </div>
        </div>

        // <div>PhotographerProfile</div>
    )
}

export default PhotographerProfile